<template>
  <header id="header">
    <div class="header-content">
      <router-link to="/" id="header-logo">
        <img
          src="../../assets/logo.png"
          alt="呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call"
        />
        <p class="logo-title">
          呼び出しベル・チャイム（ワイヤレス）<br />
          の専門店ならB-Call
        </p>
      </router-link>

      <div id="header-contact">
        <a href="tel:076-294-4440" class="contact-number">
          <p>お電話でのお問い合わせ</p>
          <span class="phone-number">TEL.076-294-4440</span>
        </a>
        <router-link to="/contact" class="contact-form">
          <img src="/static/mail-white.png" class="mail-icon" />
          <div class="contact-border" />
          <div class="contact-title">
            <p>無料お見積り</p>
            <p>デモ機貸出し</p>
            <p>お問い合わせ</p>
          </div>
        </router-link>
      </div>
    </div>

    <ul class="header-nav">
      <router-link
        v-for="(item, index) in items"
        :key="index"
        v-bind:to="item.path"
        exact
      >
        <li>{{ item.title }}</li>
      </router-link>
    </ul>
  </header>
</template>

<script>
export default {
  name: 'PcHeaderMenu',
  data() {
    return {
      items: [
        { title: 'HOME', path: '/' },
        { title: '商品一覧', path: '/products' },
        { title: '商品の選び方', path: '/choice/purpose' },
        { title: 'よくあるご質問', path: '/faq' },
        { title: 'ご購入方法', path: '/guide' },
        { title: 'デモ機貸出し方法', path: '/rental' },
        { title: 'お知らせ', path: '/news' },
        { title: 'お役立ちコラム', path: '/columns' },
        { title: '会社案内', path: '/company' },
      ],
    }
  },
}
</script>

<style scoped>
header {
  flex-direction: column;

  margin: 16px 0 0 0;
}

.header-content {
  display: flex;
  justify-content: space-between;

  margin: 0 10% 5px 10%;
}

#header-logo {
  font-size: 14px;

  display: flex;
  align-items: center;

  text-decoration: none;

  color: #4d4d4d;
}

#header-logo img {
  height: 45px;
}

.logo-title {
  margin-left: 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  line-height: 16px;
  font-weight: normal;
}

.logo-title p {
  line-height: 16px;

  margin: 0;
}

#header-contact {
  font-size: 14px;

  display: flex;
  align-items: center;
}

#header-contact .contact-number {
  margin-right: 16px;

  text-decoration: none;

  color: #4d4d4d;
}

#header-contact .contact-number p {
  font-size: 12px;
  line-height: 12px;

  margin: 0;
}

#header-contact .contact-number .phone-number {
  font-size: 22px;
  font-weight: bold;

  color: rgb(191, 41, 50);
}

#header-contact .contact-form {
  font-weight: bold;

  display: flex;
  align-items: center;

  height: 85%;
  padding: 3px;

  text-decoration: none;

  color: white;
  border-radius: 3px;
  background-color: rgb(26, 87, 167);
}

#header-contact .contact-form .mail-icon {
  width: 20px;
  height: auto;
  padding-left: 10px;
}

#header-contact .contact-form .contact-title {
  font-size: 12px;

  padding-right: 10px;
}

#header-contact .contact-form .contact-title p {
  line-height: 2px;
}

#header-contact .contact-form .contact-border {
  height: 70%;
  margin: 0 10px;

  border-left: 1px solid white;
}

.header-nav {
  font-size: 12px;
  font-weight: bold;
  line-height: 25px;

  display: flex;
  clear: both;
  justify-content: center;

  margin: auto;
  padding: 10px;

  list-style: none;

  background: linear-gradient(rgb(75, 161, 246), rgb(27, 89, 190));
}

.header-nav a {
  width: 120px;

  text-align: center;
  text-decoration: none;

  color: #eee;
  border-left: 1px solid #eee;
}

.header-nav a + :last-child {
  border-right: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/PcHeaderMenu.vue